import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const MobileSearch = () => {
  const navigate = useNavigate();
  const { products } = useSelector((state) => state.product); 
  const [query, setQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const searchRef = useRef(null);

  useEffect(() => {
    if (!query || !products?.length) {
      setSuggestions([]);
      return;
    }
    const lower = query.toLowerCase();
    const matched = products
      .filter(
        (p) =>
          p.title?.toLowerCase().includes(lower) ||
          p.name?.toLowerCase().includes(lower) ||
          p.description?.toLowerCase().includes(lower)
      )
      .slice(0, 6);
    setSuggestions(matched);
  }, [query, products]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (searchRef.current && !searchRef.current.contains(e.target)) {
        setSuggestions([]);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    const trimmed = query.trim();
    if (trimmed.length > 0) {
      navigate(`/shop-grid-filter?search=${encodeURIComponent(trimmed)}`);
      setSuggestions([]);
    }
  };

  const handleSuggestionClick = (value) => {
    navigate(`/shop-grid-filter?search=${encodeURIComponent(value)}`);
    setQuery("");
    setSuggestions([]);
  };

  return (
    <div className="offcanvas-mobile-search-area" ref={searchRef}>
      <form onSubmit={handleSubmit}>
        <input
          type="search"
          placeholder="Search products..."
          value={query}
          onChange={(e) => setQuery(e.target.value)}
        />
        <button type="submit">
          <i className="fa fa-search" />
        </button>
      </form>

      {suggestions.length > 0 && (
        <ul className="mobile-search-suggestions">
          {suggestions.map((s) => (
            <li
              key={s.id}
              onClick={() => handleSuggestionClick(s.title || s.name)}
            >
              {s.title || s.name}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default MobileSearch;
